import {useEffect, useRef} from "react";
import {getBrandedUrl} from "../api/auth";

export const SignOutRedirect = () => {
    const inputRef = useRef()

    useEffect(() => {
        window.location.href = getBrandedUrl()
    }, [inputRef])
}